export const Entities = (entities = {}) => {
  return {
    type: "HASS_ENTITIES",
    payload: entities,
  };
};
